import AscIconDark from '@Resources/assets/icons/dark/sort-asc-18x18.svg';
import DescIconDark from '@Resources/assets/icons/dark/sort-desc-18x18.svg';
import {
    SortingState,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    useReactTable,
} from '@tanstack/react-table';
import React, { useState } from 'react';
import { IBaseSettingsTableProps } from './SettingsTable';
import Styles from './SettingsTable.scss';

type IDumbSettingsTableProps<T extends object> = IBaseSettingsTableProps<T>;

export const DumbSettingsTable = <T extends object>(
    props: IDumbSettingsTableProps<T>
) => {
    const [sorting, setSorting] = useState<SortingState>([]);

    const table = useReactTable({
        data: props.data,
        columns: props.columns,
        state: {
            sorting,
        },
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
    });

    return (
        <table id={props.id} className={Styles.dumbTable}>
            <thead
                style={{
                    visibility: props.hideTableHeader ? 'hidden' : 'visible',
                }}
            >
                {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => (
                            <th
                                id={header.id}
                                key={header.id}
                                colSpan={1}
                                onClick={header.column.getToggleSortingHandler()}
                                className={
                                    header.column.getIsSorted()
                                        ? Styles.sortedTh
                                        : null
                                }
                                style={{
                                    width: header.getSize(),
                                }}
                            >
                                <div>
                                    {header.isPlaceholder
                                        ? null
                                        : flexRender(
                                              header.column.columnDef.header,
                                              header.getContext()
                                          )}
                                    {{
                                        asc: <AscIconDark />,
                                        desc: <DescIconDark />,
                                    }[header.column.getIsSorted() as string] ??
                                        null}
                                </div>
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>

            <tbody>
                {table.getRowModel().rows.map((row) => (
                    <tr id={`${props.id}-${row.id}`} key={row.id}>
                        {row.getVisibleCells().map((cell) => (
                            <td id={cell.id} key={cell.id}>
                                {flexRender(
                                    cell.column.columnDef.cell,
                                    cell.getContext()
                                )}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
